export const queueTask = (exec) => {
    let pendingBroadcast = false;
    return () => {
        if (pendingBroadcast) {
            return;
        }
        pendingBroadcast = true;
        queueMicrotask(() => {
            pendingBroadcast = false;
            exec();
        });
    };
};
